<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="auto" class="pa-0 pt-6 pr-2" v-if="icon">
        <v-icon>{{ icon }}</v-icon>
      </v-col>
      <v-col class="text-col pa-0">
        <span class="readonly-field-label text-caption primary--text">
          {{ label }}
        </span>
        <br/>
        <p v-if="value" :class="valueClass" v-html="value"/>
        <p v-else class="readonly-field-value">
          -
        </p>
        <span v-if="subValue" class="readonly-field-subvalue">
          {{ subValue }}
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ReadonlyField',
  props: ['label', 'value', 'subValue', 'icon', 'textClass'],
  computed: {
    valueClass() {
      let valueClass = this.textClass
      if (!valueClass) return
      if (valueClass.includes('text-caption')) valueClass = valueClass.concat(' pt-1')
      return valueClass
    }
  }
}
</script>

<style scoped>
.text-col {
  white-space: pre-line;
  /*max-width: calc(100% - 32px) !important;*/
}

.readonly-field-label {
  white-space: nowrap;
}

p {
  margin: 0;
}

.readonly-field-label {
  text-transform: uppercase;
  font-size: 0.65rem !important;
  letter-spacing: 0.05em;
  font-weight: 500;
  color: #78909C;
  margin-bottom: 2px;
}

.readonly-field-value {
  font-size: 0.9rem !important;
  color: #263238;
  font-weight: 500;
  line-height: 1.2;
}

.readonly-field-subvalue {
  font-size: 0.75rem !important;
  color: #90A4AE;
}
/*.row {
  border: solid 1px orange;
}
.col {
  border: solid 1px green;
}*/
</style>
